import { Box, Button, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import {
  GenericTableColumTypes,
  GenericTableFilterTypes,
} from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { v4 as uuid } from "uuid";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { RouteComponentProps } from "../../models/RouteComponent";
import { useNavigate } from "react-router-dom";
import {
  duplicateChemical,
  removeChemical,
  updateChemical,
} from "../../service/chemicalService";
import ChemicalAdd from "./chemical-Add";
import { UserTypes } from "../../enum/UserTypes";

export default function ChemicalTable(props: RouteComponentProps) {
  const navigate = useNavigate();

  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);

  const toast = useRef(null as any);

  let url = "chemical";

  const baseFilter = {
    active: { value: true, matchMode: FilterMatchMode.CONTAINS },
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    setSelectedRecord(null);
    // props.setGlobalLoader(true);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    const value = row.value;
    console.log("value == ", value);
    setSelectedRecord(value);
    viewSelected(row);
  };

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row);
    setSelectedRecord(row.value);
  };

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const client = await removeChemical(selectedRecord.id);
    props.setGlobalLoader(false);
    toast.current.show({
      severity: "success",
      summary: "Employee Deleted Successfully",
      life: 3000,
    });
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await updateChemical({ active: status }, selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({
      severity: "success",
      summary: status
        ? "Chemical Activated Successfully"
        : "Chemical Deactivated Successfully",
      life: 3000,
    });
  };

  const duplicateFunc = async () => {
    props.setGlobalLoader(true);
    const client = await duplicateChemical(selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'Chemical Duplicated Successfully', life: 3000 });
  }

  const disableConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to deactivate chemical?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => changeStatusFunc(false),
    });
  };

  const activateConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to activate chemical?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => changeStatusFunc(true),
    });
  };

  const DialogSetVisible = (row: any) => {
    setVisible(true);
  };

  const viewSelected = (row: any) => {
    console.log("View Selected Row: ", row);
    let record = selectedRecord;
    if (!record?.id) {
      if (row?.id || row.value?.id) {
        record = row.value || row;
      } else {
        return;
      }
    }
    let breadcrumbs = props.breadcrumbs;
    breadcrumbs.push({
      label: record.full_name,
      link: "/consultant-dashboard",
      userType: UserTypes.Consultant
    });
    props.setBreadcrumbs(breadcrumbs);
    if (props.setChemical) {
      console.log("Set Chemical");
      props.setChemical(record);
    }
    navigate("/chemical-view");
  };

  const contextItems = () => {
    let objArray = [
      {
        label: "View / Edit",
        icon: "pi pi-fw pi-pencil",
        command: viewSelected,
      },
      // { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: DialogSetVisible },
    ];
    if (selectedRecord?.active) {
      objArray.push({
        label: "Deactivate",
        icon: "pi pi-fw pi-times-circle",
        command: disableConfirm,
      });
    } else {
      objArray.push({
        label: "Activate",
        icon: "pi pi-fw pi-check-circle",
        command: activateConfirm,
      });
    }
    objArray.push({ label: 'Duplicate', icon: 'pi pi-fw pi-clone', command: duplicateFunc });
    objArray.push({
      label: "Delete",
      icon: "pi pi-fw pi-trash",
      command: deleteConfirm,
    });
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "name",
      header: "Name",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "description",
      header: "Description",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "type",
      header: "Type",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "active",
      header: "Active",
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "site_list",
      header: "Site",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "quantity",
      header: "Quantity",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "units",
      header: "Units",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    }
  ];

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "start", sm: "center" },
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography level="h2" component="h1">
          Chemical
        </Typography>
      </Box>

      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        url={url}
        columns={columns}
        contextItems={contextItems}
        addButton={addButton}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        header={"Add Chemical"}
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
      >
        <ChemicalAdd
          setGlobalLoading={props.setGlobalLoader}
          record={selectedRecord}
          setReload={setReload}
          uuid={uuid()}
          reload={reload}
          setVisible={setVisible}
          toast={toast}
          session={props.session}
        />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </React.Fragment>
  );
}
